import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiRadioGroup, SuiRadio, SuiTextInput } from '@splashthat/sui';

const OTHER_LABEL = 'Other';
const baseClassName = 'RadioIncludeOther';

class RadioIncludeOther extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
        onChange: PropTypes.func,
    };

    static defaultProps = {
        onChange: () => {},
        children: [],
    };

    state = {
        otherActive: false,
        otherValue: '',
    };

    handleChangeGroup = (event, activeValue, ...args) => {
        this.setState((state) => ({
            ...state,
            otherActive: activeValue === (this.state.otherValue || 'other'),
        }));

        if (this.props.onChange) {
            this.props.onChange(event, activeValue, ...args);
        }
    };

    handleChangeOther = (event, otherActive, ...args) => {
        this.setState((state) => ({
            ...state,
            otherActive,
        }));
    };

    handleChangeInput = (event, value) => {
        this.setState((state) => ({
            ...state,
            otherValue: value,
        }));

        if (this.props.onChange) {
            this.props.onChange(event, value || 'other');
        }
    };

    render() {
        return (
            <div>
                <SuiRadioGroup {...this.props} onChange={this.handleChangeGroup}>
                    {[
                        ...this.props.children,
                        <SuiRadio
                            label={OTHER_LABEL}
                            value={this.state.otherValue || 'other'}
                            onChange={this.handleChangeOther}
                            key="other"
                        />,
                    ]}
                </SuiRadioGroup>
                {this.state.otherActive && (
                    <SuiTextInput
                        fullWidth
                        className={`${baseClassName}__other-input`}
                        value={this.state.otherValue}
                        onChange={this.handleChangeInput}
                    />
                )}
            </div>
        );
    }
}

export default RadioIncludeOther;
